/*
 * axios wrap
 */

export default (Vue, { ApiAdapter }) => {
  Vue.ApiAdapter = ApiAdapter
}



// WEBPACK FOOTER //
// ./src/plugins/Api.js